// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8357cf86","453":"5565870f","667":"ab7c81e0","857":"0f1a5397"}[chunkId] + ".chunk.js";
};